import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import longinBanner from '../../assets/images/Login/SmartCityLogin.png'
import loginFormPersonImg from '../../assets/images/Login/person.svg'
import loginFormBreifCaseImg from '../../assets/images/Login/briefcase.svg'
import { CiLock, CiUser } from 'react-icons/ci';
import AuthLoader from './AuthLoader';
import PageFade from './PageFade';

const Login = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 👈 added state
  const [role, setRole] = useState('USER'); // default Staff
  const [location, setLocation] = useState({ latitude: null, longitude: null });

  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const [authLoading, setAuthLoading] = useState(false);




  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!user) return;

  //   if (user.role === "ADMIN" || user.role === "SUPER_ADMIN") {
  //     navigate("/smartcity/dashboard", { replace: true });
  //   } else {
  //     navigate("/smartcity/dashboard", { replace: true });
  //   }
  // }, [user, navigate]);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          // Fallback: Set to a specific "denied" flag or stay null
          console.warn("Location denied. Database will record NULL.");
          setLocation({ latitude: null, longitude: null });
        },
        { timeout: 5000 } // Add a timeout to prevent long-pending requests
      );
    }
  }, []); // Empty array ensures this only runs ONCE on mount

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   try {
  //     const { accessToken } = await loginUser({ id, password, role, ...location });

  //     login(accessToken);

  //   } catch (err) {
  //     if (err.response && err.response.data) {
  //       setError(err.response.data.message || err.response.data || 'Login failed');
  //     } else {
  //       setError(err.message || 'Login failed');
  //     }
  //   }
  // };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const MIN_LOADING_TIME = 2000;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setAuthLoading(true);
    try {
      const [data] = await Promise.all([
        loginUser({ id, password, role, ...location }),
        delay(MIN_LOADING_TIME)
      ]);

      // If password reset is required on first login
      if (data.mustChangePassword) {
        localStorage.setItem(
            "tempAuth",
            JSON.stringify({ userId: data.id, role: data.role })
        );
        navigate("/smartcity/reset-password", { replace: true });
        return;
      }

      login(data);

      console.log("Role : ", data.role)
      if (data.role === "ADMIN" || data.role === "SUPER_ADMIN") {
        // Matches: <Route path="/smartcity/admin/dashboard" ... />
        navigate("/smartcity/admin/dashboard", { replace: true });
      } else {
        // Matches: <Route path="/smartcity/dashboard" ... />
        navigate("/smartcity/dashboard", { replace: true });
      }

    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'Login failed';
      setError(errorMsg);
      console.error(errorMsg);
    } finally {
      setAuthLoading(false);
    }
  };

  const navigateToRegister = () => {
    navigate('/smartcity/register')
  }

  return (
    <PageFade>
      {authLoading && <AuthLoader text="Signing you in securely..." />}

      <div className='login-header box-shadow'>
        <nav className="container-fluid flex justify-between items-center px-[15px] h-[75px]">
          <strong className="w-[500px] text-[25px] text-[#6271bb]" >Demo Municipal Corporation</strong>
        </nav>
      </div>
      <div className='login-wrap flex md:top-10 relative flex-wrap justify-center items-center'>
        <div className='container'>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center md:gap-6">
            {/* Left Column - Image */}
            <div className="md:col-span-2 h-full">
              <img src={longinBanner} alt="Img not found" className="w-full h-full" />
            </div>

            {/* Right Column - Form */}
            <div className="md:col-span-1 flex justify-center">
              <div className="login-box border rounded-[10px] bg-white shadow-md">
                <div className='login-title'>
                  <h2 className="text-center loginfont">Login</h2>
                  <h5 className='text-center loginfont'>Smart City</h5>
                </div>

                {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="select-role">
                    <div className="btn-group btn-group-toggle" data-toggle="buttons">

                      <label className={`btn cursor-pointer ${role === 'USER' ? 'active' : ''}`}>
                        <input
                          type="radio"
                          name="role"
                          id="user"
                          value="USER"
                          checked={role === 'USER'}
                          onChange={(e) => setRole(e.target.value)}
                          className="hidden"
                        />
                        <div className="icon mb-2 w-8 h-8">
                          <img src={loginFormPersonImg} className="" alt="Staff" />
                        </div>
                        <span className="text-xs font-medium">I'm</span>
                        <span className="font-bold">Staff</span>
                      </label>

                      <label className={`btn cursor-pointer  ${role === 'ADMIN' ? 'active' : ''}`}>
                        <input
                          type="radio"
                          name="role"
                          id="admin"
                          value="ADMIN"
                          checked={role === 'ADMIN'}
                          onChange={(e) => setRole(e.target.value)}
                          className="hidden"
                        />
                        <div className="icon">
                          <img src={loginFormBreifCaseImg} className="" alt="Admin" />
                        </div>
                        <span className="">I'm</span>
                        <span className="">Admin</span>
                      </label>

                    </div>
                  </div>

                  <div className='input-group custom'>
                    <input
                      id="id"
                      type="text"
                      placeholder='Enter Id'
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      className="mt-1 px-3 py-2 border form-control-login border-gray-300 rounded-md w-full outline-blue-500"
                      required
                    />
                    <div className='input-group-append custom'>
                      <span className='input-group-text'>
                        <CiUser className='login-input-icon' />
                      </span>
                    </div>
                  </div>
                  <div className='input-group input-group-login-password mb-0 custom'>
                    <input
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      placeholder="**********"
                      onChange={(e) => setPassword(e.target.value)}
                      className="mt-1 px-3 outline form-control-login py-2 border border-gray-300 rounded-md w-full outline-blue-500"
                      required
                    />
                    <div className='input-group-append custom'>
                      <span className='input-group-text'>
                        <CiLock className='login-input-icon' />
                      </span>
                    </div>
                  </div>
                  <div className="mb-[25px] flex pl-1 items-center">
                    <input
                      type="checkbox"
                      id="showPasswordToggle"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)}
                      className="mr-2"
                    />
                    <label htmlFor="showPasswordToggle" className="text-sm">
                      Show Password
                    </label>
                  </div>
                  <div>
                    <div>
                      <div className='input-group mb-0'>
                        <button
                          type="submit"
                          disabled={authLoading}
                          className={`w-full btn btn-primary btn-lg btn-block ${authLoading ? "opacity-70 cursor-not-allowed" : ""}`}
                        >
                          {authLoading ? "Logging in..." : "Login"}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <p className="mb-2">
                    Don't have account?{' '}
                    <span
                      className="text-blue-500 cursor-pointer hover:underline"
                      onClick={navigateToRegister}
                    >
                      Register
                    </span>
                  </p> */}


                </form>

                <p className="mt-4 mb-2 text-right">
                  Forgot password?{' '}
                  <span
                    className="text-blue-500 cursor-pointer hover:underline"
                    onClick={() => navigate('/forgot-password')}
                  >
                    Reset here
                  </span>
                </p>
              </div>
            </div>
          </div>

        </div>


      </div>
    </PageFade>
  );
};

export default Login;
